import type { KycFeatureConfig } from '../type';

export const kyc: KycFeatureConfig = {
    handoverTargetClientId: '',
    passCustomerSegmentInHandover: false,
    oidcReady: false,
    target: '',
    passParamsInQuery: false,
    preferTokenExchange: false,
    passCurrentAccessToken: false,
    handoffModePaths: { required: '', optional: '' },
    handoffModeQueryParams: { required: {}, optional: {} },
};
